<template>
	<NuxtLayout>
		<NuxtLoadingIndicator :color="`#de005d`" />
		<NuxtPage />
	</NuxtLayout>
</template>
